import { useState } from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs.ui";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function AccountPartial() {
  const { pathname } = useLocation();
  const tab = pathname.split("/").pop();
  const initialTab = tab ? tab : "profile";
  const [activeTab, setActiveTab] = useState(initialTab);
  const navigate = useNavigate();
  return (
    <div className="bg-white py-4 w-full h-full overflow-x-auto">
      <div className="flex flex-col h-full">
        <h2 className="mb-4 px-5 md:pt-5 md:pl-12 font-cabinetgrotesk font-semibold text-2xl">
          Your account
        </h2>
        <Tabs
          className="flex flex-col h-full"
          value={activeTab}
          onValueChange={(value) => {setActiveTab(value);
            navigate(`/brands/account/${value}`);
          }}
        >
          <div className="top-0 z-10 md:sticky bg-white py-1.5 pl-16 border-black border-t border-b w-full">
            <TabsList className="flex justify-between w-80 font-cabinetgrotesk">
              <TabsTrigger value="profile">Profile</TabsTrigger>
            </TabsList>
          </div>
          <TabsContent className="flex-1" value={activeTab}>
            <Outlet />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
